/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Dashboard_Complete_CountInputs */

const en_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} complete`)
};

const de_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} abgeschlossen`)
};

const fr_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} terminé`)
};

const es_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} completado`)
};

const it_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} completato`)
};

const nl_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} voltooid`)
};

const pl_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} ukończone`)
};

const fi_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} valmis`)
};

const da_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} fuldført`)
};

const sv_dashboard_complete_count = /** @type {(inputs: Dashboard_Complete_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.completed}/${i?.total} klart`)
};

/**
* | output |
* | --- |
* | "{completed}/{total} complete" |
*
* @param {Dashboard_Complete_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_complete_count = /** @type {((inputs: Dashboard_Complete_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Complete_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_complete_count(inputs)
	if (locale === "fr") return fr_dashboard_complete_count(inputs)
	if (locale === "es") return es_dashboard_complete_count(inputs)
	if (locale === "it") return it_dashboard_complete_count(inputs)
	if (locale === "nl") return nl_dashboard_complete_count(inputs)
	if (locale === "pl") return pl_dashboard_complete_count(inputs)
	if (locale === "fi") return fi_dashboard_complete_count(inputs)
	if (locale === "da") return da_dashboard_complete_count(inputs)
	if (locale === "sv") return sv_dashboard_complete_count(inputs)
	return en_dashboard_complete_count(inputs)
});